<p-dialog
  header="Change Additional Charge Status"
  [(visible)]="visible"
  [responsive]="true"
  [modal]="true"
  [style]="{ width: '400px' }"
  (onHide)="closeExpenseStatusDialog()"
>
  <div class="ui-g" style="position: relative">
    <div class="ui-g-12">
      <div class="ui-grid-col-4">
        <label>Status</label>
      </div>
      <div class="ui-grid-col-8">
        <p-dropdown
          appendTo="body"
          [options]="statusOptions"
          [filter]="true"
          [style]="{ width: '100%' }"
          [(ngModel)]="selectedStatus"
        ></p-dropdown>
      </div>
    </div>
  </div>

  <p-footer class="no-rounded-top-border rounded-bottom-border">
    <div style="text-align: right">
      <button
        type="button"
        (click)="closeExpenseStatusDialog()"
        pButton
        label="Close"
        class="ui-button ui-button-tertiary"
      ></button>
      <button
        type="button"
        pButton
        label="Save"
        class="ui-button ui-button-primary"
        (click)="saveChangeExpenseStatus()"
      ></button>
    </div>
  </p-footer>
</p-dialog>
